import styled from "styled-components";
import { THEME } from "../../styles/theme";

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const AssociationsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding-bottom: 1rem;
  padding: 2rem;
  border-radius: 1.5rem;
  background-color: ${THEME.palette.background.paper};
  overflow-y: auto;
  flex: 1;
`;

export const CategoriesContainer = styled.div`
  position: relative;
  min-height: 2.4rem;
  overflow-x: auto;
  overflow-y: hidden;
  margin-left: -2rem;
  margin-right: -2rem;
  ::-webkit-scrollbar {
    display: none;
  }

  > section {
    margin-left: 2rem;
    position: absolute;
    display: flex;
    gap: 0.5rem;
  }
`;
